<script>
    import {GPHardinessData} from './gp-hardiness.js';
    import jQuery from "jquery";
    import {soilSettings} from "./gp.js";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-soilsettings");

    let soilTypePHValues = [
        {
            id: 'GPSoilPHAcid',
            label: "Acidic"
        }, {
            id: 'GPSoilPHNeutral',
            label: "Neutral"
        }, {
            id: 'GPSoilPHAlcaline',
            label: "Alcaline"
        }
    ]
    let soilRichnessValues = [
        {
            id: 'GPSoilRichnessRich',
            label: "Rich"
        }, {
            id: 'GPSoilRichnessAverage',
            label: "Average"
        }, {
            id: 'GPSoilRichnessPoor',
            label: "Poor"
        }
    ]
    let soilHumidityValues = [
        {
            id: 'GPSoilHumidityHumid',
            label: "Humid"
        }, {
            id: 'GPSoilHumidityAverage',
            label: "Average"
        }, {
            id: 'GPSoilHumidityDry',
            label: "Dry"
        }
    ]

    export let soilTypePH;
    export let soilTypeQuality;
    export let soilHumidity;
    export let zone;
    export let countryId;
    export let regionId;
    export let project;
    let country;
    let region;
    let storeParams;

    export function open() {
        jQuery('#GPClimateParameters').modal({});
        jQuery('#GPClimateParameters').on('hidden.bs.modal', () => this.$destroy());

        if (countryId) country = GPHardinessData.zones.filter(z => z["-id"] === countryId)[0];
        if (regionId) region = GPHardinessData.zones.flatMap(el => el["pr"] ? el["pr"] : []).filter(z => z["-id"] === regionId)[0];

        //trap focus
        jQuery('#GPClimateParameters .modal-header .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPClimateParametersApply').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});
    }

    function applyValues() {
        project.soilTypeQuality = soilTypeQuality;
        project.soilTypePH = soilTypePH;
        project.soilHumidity = soilHumidity;
        project.zone = zone;
        project.ctr = countryId;
        project.region = regionId;
        soilSettings.set({});
        if (storeParams)
            localStorage['GPSoilSettings'] = JSON.stringify({
                soilTypePH: soilTypePH,
                soilTypeQuality: soilTypeQuality,
                soilHumidity: soilHumidity,
                zone: zone,
                countryId: countryId,
                regionId: regionId
        })
    }
</script>

<div class="modal fade GPModal" tabindex='-1' id="GPClimateParameters">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Set soil & climate parameters")}</h4>
            </div>
            <div class="modal-body">

                <h4>{trans("Specify soil parameters to filter out not optimal plants")}</h4>

                <div class="GPSoilParam">

                    <label class="GPSoilLabels">PH:</label>
                    <div class="btn-group btn-group-justified GPSoilToggler" >
                        {#each soilTypePHValues as val}
                            <label class="btn btn-default {soilTypePH === val.id ? 'active' : ''}">
                                <input type="radio" bind:group={soilTypePH} value='{val.id}'> {trans( val.label)}
                            </label>
                        {/each}
                    </div>
                    <button type="button" class="close GPSoilParamReset" on:click={() => {soilTypePH = ''}}><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="GPSoilParam">
                    <label class="GPSoilLabels">{trans("Richness")}:</label>
                    <div class="btn-group btn-group-justified GPSoilToggler" >
                        {#each soilRichnessValues as val}
                            <label class="btn btn-default {soilTypeQuality === val.id ? 'active' : ''}">
                                <input type="radio" bind:group={soilTypeQuality} value='{val.id}'> {trans(val.label)}
                            </label>
                        {/each}
                    </div>
                    <button type="button" class="close GPSoilParamReset" on:click={() => {soilTypeQuality = ''}}><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="GPSoilParam">
                    <label class="GPSoilLabels">{trans("Humidity")}:</label>
                    <div class="btn-group btn-group-justified GPSoilToggler" >
                        {#each soilHumidityValues as val}
                            <label class="btn btn-default {soilHumidity === val.id ? 'active' : ''}">
                                <input type="radio" bind:group={soilHumidity} value='{val.id}'> {trans(val.label)}
                            </label>
                        {/each}
                    </div>
                    <button type="button" class="close GPSoilParamReset" on:click={() => {soilHumidity = ''}}><span aria-hidden="true">&times;</span></button>
                </div>


                <h4>{trans("Select region or set hardiness zone manually")} </h4>

                <div class="GPSoilParam">
                    <label class="GPSoilLabels" for="GPRegionSelect">{trans("Region")}:</label>
                    <select id="GPRegionSelect" class="btn btn-default" bind:value="{country}"
                            on:change="{() => {zone = country['-zone']; countryId = country['-id']; region = null; regionId = null}}">
                        <option selected="selected" value="null">{trans("Country")}</option>
                        {#each GPHardinessData.zones as zone }
                            <option class="GPSoilCountryItem" value={zone}>{trans(zone['-name'],zone['-name'])}</option>
                        {/each}
                    </select>
                    {#if country && country['pr']}
                        <select id="GPStateSelect" class="btn btn-default" bind:value="{region}" on:change="{() => {zone = region['-zone']; regionId = region['-id']}}">
                            <option selected="selected" value="null">{trans("Region")}</option>
                            {#each country['pr'] as zone }
                                <option class="GPSoilCountryItem" value={zone}>{zone['-name']}</option>
                            {/each}
                        </select>
                    {/if}
                </div>
                <div class="GPSoilParam">
                    <label class="GPSoilLabels">{trans("Zone")}:</label>
                    <span id="GPHardinessSliderValue">{zone?zone:'-'}</span>
                    <input type=range bind:value={zone} min=1 max=11>
                    <button type="button" class="close GPSoilSliderReset" on:click={()=>{zone = null; country="null"; region="null"}}><span aria-hidden="true">&times;</span></button>
                </div>
            </div>
           <div class="modal-footer">
                <div class="checkbox GPSoilParamsStore">
                    <label>
                        <input type="checkbox" bind:checked={storeParams}> {trans("Store as default")}
                    </label>
                </div>
                <button type="button" class="btn btn-default" data-dismiss="modal" >{trans("Cancel")}</button>
                <button id="GPClimateParametersApply" type="button" class="btn btn-primary" data-dismiss="modal" on:click={applyValues} >{trans("Apply")}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->